/**
 * type shape of errors that could occurrs when performing a plugin call
 */
export var StorageManagerMetadataErrorType;
(function (StorageManagerMetadataErrorType) {
    StorageManagerMetadataErrorType["streamError"] = "streamError";
    StorageManagerMetadataErrorType["streamIsNull"] = "streamIsNull";
    StorageManagerMetadataErrorType["streamIsUnreadable"] = "streamIsUnreadable";
    StorageManagerMetadataErrorType["fileError"] = "fileError";
    StorageManagerMetadataErrorType["fileNotFoundInDisc"] = "fileNotFoundInDisc";
    StorageManagerMetadataErrorType["fileNotFoundInMetadata"] = "fileNotFoundInMetadata";
    StorageManagerMetadataErrorType["fileMimeTypeNotProvided"] = "fileMimeTypeNotProvided";
    StorageManagerMetadataErrorType["fileMimeTypeCheck"] = "fileMimeTypeCheck";
    StorageManagerMetadataErrorType["fileMetadataIsNull"] = "fileMetadataIsNull";
    StorageManagerMetadataErrorType["fileOrResourceRemovalError"] = "fileOrResourceRemovalError";
    StorageManagerMetadataErrorType["fileMetadataStorageTypeMismatchError"] = "fileMetadataStorageTypeMismatchError";
    StorageManagerMetadataErrorType["byteArrayError"] = "byteArrayError";
    StorageManagerMetadataErrorType["byteArrayIsNull"] = "byteArrayIsNull";
    StorageManagerMetadataErrorType["parameterError"] = "parameterError";
    StorageManagerMetadataErrorType["retentionPolicyViolationError"] = "retentionPolicyViolationError";
    StorageManagerMetadataErrorType["resultError"] = "resultError";
    StorageManagerMetadataErrorType["noResultsFoundError"] = "noResultsFoundError";
    StorageManagerMetadataErrorType["internalError"] = "internalError";
    StorageManagerMetadataErrorType["invalidOperationError"] = "invalidOperationError";
    StorageManagerMetadataErrorType["invalidCastError"] = "invalidCastError";
    StorageManagerMetadataErrorType["argumentNull"] = "argumentNull";
})(StorageManagerMetadataErrorType || (StorageManagerMetadataErrorType = {}));
/**
 * Scope used for storing, retrieving, listing, or removing resources.
 */
export var StorageManagerScope;
(function (StorageManagerScope) {
    StorageManagerScope["global"] = "global";
    StorageManagerScope["tenant"] = "tenant";
})(StorageManagerScope || (StorageManagerScope = {}));
//# sourceMappingURL=storage-manager.js.map